import backend from "../../../../backend/backend";
import label from "../../../../i18n/label";
import Notify from "../../../shared/Notify";
import AssistantActions from "./assistantActions";

export const loadAssistants = (intl, workspaceId) => {
  return (dispatch) => {
    backend
      .getAssistants(workspaceId)
      .then((list) => {
        dispatch({
          type: AssistantActions.LOADED_LIST,
          list,
        });
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const loadAssistant = (intl, workspaceId, assistantUid) => {
  return (dispatch) => {
    backend
      .getAssistant(workspaceId, assistantUid)
      .then((assistant) => {
        dispatch({
          type: AssistantActions.LOADED_ASSISTANT,
          assistant,
        });
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const createAssistant = (intl, workspaceId, data, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .createAssistant(workspaceId, data)
      .then((assistant) => {
        dispatch({
          type: AssistantActions.CREATED_ASSISTANT,
          assistant,
        });
        Notify.success(label(intl, "assistant_created"));
        if (onSuccess) onSuccess(assistant);
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
        if (onError) onError();
      });
  };
};

export const updateAssistant = (
  intl,
  workspaceId,
  assistantUid,
  data,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    backend
      .updateAssistant(workspaceId, assistantUid, data)
      .then((assistant) => {
        dispatch({
          type: AssistantActions.UPDATED_ASSISTANT,
          assistant,
        });
        Notify.success(label(intl, "assistant_updated"));
        if (onSuccess) onSuccess(assistant);
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
        if (onError) onError();
      });
  };
};

export const deleteAssistant = (intl, workspaceId, assistantUid, onSuccess) => {
  return (dispatch) => {
    backend
      .deleteAssistant(workspaceId, assistantUid)
      .then(() => {
        dispatch({
          type: AssistantActions.DELETED_ASSISTANT,
          assistantUid,
        });
        Notify.success(label(intl, "assistant_deleted"));
        if (onSuccess) onSuccess();
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};
